import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Url } from '../common/url';

@Injectable({
  providedIn: 'root'
})
export class PowertrainService extends DataService {

  constructor(http: HttpClient, private localHttp : HttpClient) { 
    super('powertrain', http);
  }

  url : string = Url.powertrain;

  getAll(){
    return this.localHttp.get(this.url + '?filter[include]=motors&filter[order]=code ASC');
  }
}
